import { Box } from "@mui/material";

export default function BackgroundVideo() {
    return (
        <>
            <video
                src="/media/bg.mp4"
                autoPlay
                muted
                loop
                playsInline
                poster="/media/bg.png"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    zIndex: -1,
                    backgroundColor: "#3e5151",
                    background: "linear-gradient(to left, #decba4, #3e5151bd)",
                }}
            />

            <Box
                sx={{
                    position: "fixed",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(0,0,0,0.2), rgba(0,0,0,0.7))",
                    zIndex: -1,
                }}
            />
        </>
    );
}